import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { INBOX_FILTER_INITIAL_STATE } from '../sic-lib/defaults';
import { InboxFilter } from '../sic-lib/types/InboxTypes';

// --------------
// STATE

export interface InboxState {
    filters: InboxFilter;
    //pagination & refreshing tools
}

const initialState: InboxState = {
    filters: INBOX_FILTER_INITIAL_STATE,
    // selectedItemIds: [],
};

//new redux toolkit slice implementation
const inboxSlice = createSlice({
    name: 'inbox',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<{ filter: Partial<InboxFilter> }>) => {
            const { filter } = action.payload;
            state.filters = { ...state.filters, ...filter };
        },
        clearFilters: (state, action: PayloadAction) => {
            state.filters = INBOX_FILTER_INITIAL_STATE;
        },
        // clearSelected: (state) => {
        //     state.selectedItemIds = state.selectedItemIds.slice(0,0)
        // },
        // setSelect: (state, action: PayloadAction<{messageId: number, status: boolean}>) => {
        //     const { messageId, status } = action.payload
        //     state.selectedItemIds = state.selectedItemIds.indexOf(messageId) == -1
        //         ? [...state.selectedItemIds, messageId]
        //         : state.selectedItemIds.filter(itm => itm != messageId)
        // },
    },
});

export const { setFilters, clearFilters } = inboxSlice.actions;

export default inboxSlice.reducer;
